import { IResponse, consumer } from "@bemap/utils"
import { IProfile } from "@bemap/utils"

export const getPeople = async (): Promise<IResponse> => {
  let url = `/profiles`

  try {
    return await consumer('GET', url)
  } catch (error: any) {
    const msg = error.response?.data?.message || 'An error occurred';
    throw {
      statusCode: error.response?.status || 500,
      message: msg
    }
  }
}

export const getPerson = async (id: number): Promise<IResponse> => {
  let url = `/profiles/${id}`

  try {
    return await consumer('GET', url)
  } catch (error: any) {
    const msg = error.response?.data?.message || 'An error occurred';
    throw {
      statusCode: error.response?.status || 500,
      message: msg
    }
  }
}

export async function newPerson(payload: IProfile): Promise<IResponse> {
  const url = `/profiles`

  try {
    return await consumer('POST', url, payload);
  } catch (error: any) {
    const msg = error.response?.data?.message || 'An error occurred';
    throw {
      statusCode: error.response?.status || 500,
      message: msg
    }
  }
}

export const updatePerson = async (payload: IProfile, listId?: number): Promise<IResponse> => {
  const url = listId ? `/profiles/${payload.id}?listId=${listId}` : `/profiles/${payload.id}`

  try {
    return await consumer('PATCH', url, payload);
  } catch (error: any) {
    const msg = error?.message || 'An error occurred';
    throw {
      statusCode: error?.statusCode || 500,
      message: msg
    }
  }
}

export async function deletePerson(id: number): Promise<IResponse> {
  const url = `/profiles/${id}`

  try {
    return await consumer('DELETE', url);
  } catch (error: any) {
    const msg = error.response?.data?.message || 'An error occurred';
    throw {
      statusCode: error.response?.status || 500,
      message: msg
    }
  }
} 